import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import ValuationResultPage from './pages/ValuationResultPage';
import BuyerStrategyPage from './pages/BuyerStrategyPage';
import BuyerStrategyResultPage from './pages/BuyerStrategyResultPage';
import BuyPropertyPage from './pages/BuyPropertyPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import DisclaimerPage from './pages/DisclaimerPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import SellFlatIndirapuramPage from './pages/SellFlatIndirapuramPage';
import SellFlatVaishaliPage from './pages/SellFlatVaishaliPage';
import SellFlatVasundharaPage from './pages/SellFlatVasundharaPage';
import Buy2BHKIndirapuramPage from './pages/Buy2BHKIndirapuramPage';
import Buy2BHKVaishaliPage from './pages/Buy2BHKVaishaliPage';
import Buy2BHKVasundharaPage from './pages/Buy2BHKVasundharaPage';
import Buy3BHKIndirapuramPage from './pages/Buy3BHKIndirapuramPage';
import Buy3BHKVaishaliPage from './pages/Buy3BHKVaishaliPage';
import Buy3BHKVasundharaPage from './pages/Buy3BHKVasundharaPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/valuation-result" element={<ValuationResultPage />} />
          <Route path="/buyer-strategy" element={<BuyerStrategyPage />} />
          <Route path="/buyer-strategy-result" element={<BuyerStrategyResultPage />} />
          <Route path="/buy-property" element={<BuyPropertyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/sell-flat-in-indirapuram" element={<SellFlatIndirapuramPage />} />
          <Route path="/sell-flat-in-vaishali" element={<SellFlatVaishaliPage />} />
          <Route path="/sell-flat-in-vasundhara" element={<SellFlatVasundharaPage />} />
          <Route path="/buy-2bhk-in-indirapuram" element={<Buy2BHKIndirapuramPage />} />
          <Route path="/buy-2bhk-in-vaishali" element={<Buy2BHKVaishaliPage />} />
          <Route path="/buy-2bhk-in-vasundhara" element={<Buy2BHKVasundharaPage />} />
          <Route path="/buy-3bhk-in-indirapuram" element={<Buy3BHKIndirapuramPage />} />
          <Route path="/buy-3bhk-in-vaishali" element={<Buy3BHKVaishaliPage />} />
          <Route path="/buy-3bhk-in-vasundhara" element={<Buy3BHKVasundharaPage />} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
